import React, { useState, useEffect } from 'react';
import { KatRow, KatColumn, KatInput, KatDataTable, KatPagination } from '@amzn/katal-react';
import { OFA_TESTS_HEADER } from 'src/components/constants/dataTableHeaders';
import { TestCase } from 'src/components/types/TestCase';
import { fetchTestCases } from 'src/components/helper/testCaseDataHelper';
import './css/TestCaseData.css';

const OFATestCaseData: React.FC = () => {
    const [testCases, setTestCases] = useState<TestCase[]>([]);
    const [filteredTestCases, setFilteredTestCases] = useState<TestCase[]>([]);
    const [searchTerm, setSearchTerm] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    const handleSearchChange = (term: string) => {
        setSearchTerm(term);
        const lowerTerm = term.trim().toLowerCase();

        if (lowerTerm === '') {
            setFilteredTestCases(testCases);
            return;
        }

        const matchesSearch = (value: any) => {
            if (typeof value !== 'string' && typeof value !== 'number') return false;
            return String(value).toLowerCase().includes(lowerTerm);
        };

        const filtered = testCases.filter((test) =>
            Object.values(test).some((val) => matchesSearch(val))
        );

        setFilteredTestCases(filtered);
    };

    useEffect(() => {
        const loadTestCases = async () => {
            const cases = await fetchTestCases('OFA', false);
            setTestCases(cases);
        };
        loadTestCases();
    }, []);

    useEffect(() => {
        handleSearchChange(searchTerm);
    }, [testCases]);

    const paginatedTestCases = filteredTestCases.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    return (
        <div className="test-case-section">
            <h4 style={{ marginBottom: '16px' }}>Available OFA Test Cases</h4>

            <KatRow>
                <KatColumn xs={12}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <KatInput
                            type="search"
                            placeholder="Search..."
                            value={searchTerm}
                            onInput={(e: KatInput.ChangeEvent) => handleSearchChange(e.currentTarget.value)}
                            size="small"
                        />
                    </div>
                </KatColumn>
            </KatRow>

            <KatRow>
                <KatColumn xs={12}>
                    <KatDataTable
                        columns={OFA_TESTS_HEADER}
                        rowData={paginatedTestCases}
                    />
                    <KatPagination
                        page={currentPage}
                        totalItems={filteredTestCases.length}
                        itemsPerPage={itemsPerPage}
                        variant="footer"
                        onChange={(e) => setCurrentPage(e.detail.page)}
                        onItemsPerPageChange={(e) => {
                            setItemsPerPage(e.detail.value);
                            setCurrentPage(1); // Reset to first page
                        }}
                    />
                </KatColumn>
            </KatRow>
        </div>
    );
};

export default OFATestCaseData;
